module.exports = __webpack_public_path__ + "img/2.04ddd429.webp";